import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { useAccountRoleListAll } from '../api/account-roles'
import { useUserGet, useUserSetRole } from '../api/users'
import { UsersForm } from './users-form'

export function UsersEdit() {
	const { id } = useParams()
	const { data, isSuccess, dataUpdatedAt } = useUserGet(id as string)
	const { mutate, isPending } = useUserSetRole(id as string)
	const { data: roles } = useAccountRoleListAll()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<UsersForm
			key={dataUpdatedAt}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
			roles={roles}
		/>
	)
}
